import { Form } from "@client/content/controls";
import { getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps, type FormFieldInfo } from "@client/controls/Form/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type ProductDetail } from "../../../types";

export type MapProps = RootContainerProps & {
  isAdd: boolean;
  formFields: FormFieldInfo[];

  reviewError: string | null;
  status: ProductDetail.Status;
};

export interface ActionProps {
  onSubmit: (data: ProductDetail.View.AddEditProductReview) => void;
}

export type Props = ActionProps & MapProps;

const FormButton = (props: FormButtonProps & Props) => {
  const i18n = useI18n();

  return (
    <ModuleButton
      {...getRootContainerProps(props)}
      onClick={props.ifValidated(props.onSubmit)}
      isDisabled={props.status === "SavingReview"}
    >
      {props.isAdd ? i18n.addReview : i18n.editReview}
    </ModuleButton>
  );
};

export default (props: Props) => (
  <Form
    {...getRootContainerProps(props)}
    Button={FormButton}
    buttonProps={props}
    showStars
    isInline={false}
    fields={props.formFields}
    error={props.reviewError}
    resetOnSubmit
  />
);
